$('.hero-video').on('ended', function () {
    $('.poster').removeClass("d-none");
    $('.hero-video').removeAttr("autoplay");
});